import IncludePropertyInEvents from "../../../../contents/docs/integrate/feature-flags-code/_snippets/include-feature-flag-property-in-backend-events.mdx";
import PHPOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/php.mdx";
import * as React from 'react';
export default {
  IncludePropertyInEvents,
  PHPOverrideServerProperties,
  React
};